import { BaseDataDefinition } from "./BaseDataDefinition";
import { DataTypes } from "../DataTypes";
import { ValidationIssue } from "../../IDesignValidationProvider";
import type { AppGlueAny } from "../../AppGlueAny";

export class UndefinedDataDefinition extends BaseDataDefinition<AppGlueAny> {
    readonly type: DataTypes = DataTypes.UNDEFINED;

    convert(value: AppGlueAny): AppGlueAny {
        return value;
    }

    // eslint-disable-next-line
    verifyValueType(value: AppGlueAny): ValidationIssue | undefined {
        return undefined;
    }

    // eslint-disable-next-line
    toJSONObject(value: AppGlueAny): object {
        throw new Error("Should not be called");
    }
}
